import { isoLanguageCodes } from "./Languages";

export interface ContinuePrompt {
  promptText: string;
  cancelText: string;
  confirmText: string;
}

const ContinuePrompts: {
  [languageCode in isoLanguageCodes]?: ContinuePrompt;
} = {
  // "mul" used as fallback if language not found
  mul: {
    promptText: "Continue in chosen language?",
    cancelText: "Cancel",
    confirmText: "Confirm"
  },
  ar: {
    promptText: "هل تريد المتابعة باللغة العربي",
    cancelText: "إلغاء",
    confirmText: "تأكيد"
  },
  bg: {
    promptText: "Искате ли да продължите на български?",
    cancelText: "отмяна",
    confirmText: "потвърждаване"
  },
  cs: {
    promptText: "Chcete pokračovat v češtině?",
    cancelText: "Zrušit",
    confirmText: "Potvrdit"
  },
  en: {
    promptText: "Do you want to continue in English?",
    cancelText: "Cancel",
    confirmText: "Confirm"
  },
  da: {
    promptText: "Fortsæt på dette sprog?",
    cancelText: "Afbryd",
    confirmText: "Bekræft"
  },
  de: {
    promptText: "Möchten Sie auf Deutsch fortfahren?",
    cancelText: "Abbrechen",
    confirmText: "Bestätigen"
  },
  el: {
    promptText: "Θέλετε να συνεχίσετε στα Ελληνικά",
    cancelText: "Άκυρο",
    confirmText: "Επιβεβαίωση"
  },
  es: {
    promptText: "¿Deseas continuar en español?",
    cancelText: "Cancelar",
    confirmText: "Confirmar"
  },
  "es-419": {
    promptText: "¿Deseas continuar en español?",
    cancelText: "Cancelar",
    confirmText: "Confirmar"
  },
  "es-ES": {
    promptText: "¿Deseas continuar en español?",
    cancelText: "Cancelar",
    confirmText: "Confirmar"
  },
  "es-MX": {
    promptText: "¿Deseas continuar en español?",
    cancelText: "Cancelar",
    confirmText: "Confirmar"
  },
  fr: {
    promptText: "Voulez-vous continuer en français?",
    cancelText: "Annuler",
    confirmText: "Confirmer"
  },
  "fr-FR": {
    promptText: "Voulez-vous continuer en français?",
    cancelText: "Annuler",
    confirmText: "Confirmer"
  },
  "fr-CA": {
    promptText: "Voulez-vous continuer en français?",
    cancelText: "Annuler",
    confirmText: "Confirmer"
  },
  he: {
    promptText: "רוצה להמשיך בעברית?",
    cancelText: "ביטול",
    confirmText: "אישור"
  },
  hr: {
    promptText: "Želite li nastaviti na hrvatskom jeziku? ",
    cancelText: "Otkaži",
    confirmText: "Potvrdi"
  },
  hu: {
    promptText: "Szeretné magyarul folytatni?",
    cancelText: "Mégse",
    confirmText: "Megerősítés"
  },
  id: {
    promptText: "Apakah Anda ingin meneruskan dengan Bahasa Indonesia?",
    cancelText: "Batalkan",
    confirmText: "Konfirmasikan"
  },
  it: {
    promptText: "Vuoi proseguire in italiano?",
    cancelText: "Annulla",
    confirmText: "Conferma"
  },
  ja: {
    promptText: "日本語で続行しますか？",
    cancelText: "キャンセル",
    confirmText: "確定"
  },
  ko: {
    promptText: "한국어로 계속 진행하시겠습니까?",
    cancelText: "취소",
    confirmText: "확인"
  },
  nl: {
    promptText: "Wilt u doorgaan in het Nederlands?",
    cancelText: "Annuleren",
    confirmText: "Bevestigen"
  },
  pl: {
    promptText: "Czy nadal chcesz korzystać z wersji w języku polskim?",
    cancelText: "Anuluj",
    confirmText: "Potwierdź"
  },
  "pt-BR": {
    promptText: "Gostaria de continuar em português?",
    cancelText: "Cancelar",
    confirmText: "Confirmar"
  },
  pt: {
    promptText: "Pretende continuar em português?",
    cancelText: "Cancelar",
    confirmText: "Confirmar"
  },
  ro: {
    promptText: "Doriți să continuați în limba română?",
    cancelText: "Anulare",
    confirmText: "Confirmare"
  },
  ru: {
    promptText: "Продолжить на русском?",
    cancelText: "Отменить",
    confirmText: "Подтвердить"
  },
  sk: {
    promptText: "Želáte si pokračovať v slovenčine?",
    cancelText: "Zrušiť",
    confirmText: "Potvrdit"
  },
  sr: {
    promptText: "Želite li da nastavite na srpskom?",
    cancelText: "Otkaži",
    confirmText: "Potvrdi"
  },
  sv: {
    promptText: "Vill du fortsätta på svenska?",
    cancelText: "Avbryt",
    confirmText: "Bekräfta"
  },
  th: {
    promptText: "คุณต้องการดำเนินการต่อในภาษาไทยหรือไม่",
    cancelText: "ยกเลิก",
    confirmText: "ยืนยัน"
  },
  tr: {
    promptText: "Türkçe dilinde devam etmek ister misiniz?",
    cancelText: "İptal Et",
    confirmText: "Onayla"
  },
  uk: {
    promptText: "Хочете продовжити українською?",
    cancelText: "Скасувати",
    confirmText: "Підтвердити"
  },
  vi: {
    promptText: "Bạn có muốn tiếp tục sử dụng Tiếng Việt không?",
    cancelText: "Huỷ",
    confirmText: "Xác nhận"
  },
  "zh-Hans": {
    promptText: "您是否希望继续使用中文？",
    cancelText: "取消",
    confirmText: "确认"
  },
  "zh-Hant": {
    promptText: "您是否希望繼續使用中文？",
    cancelText: "取消",
    confirmText: "確認"
  }
};

export default ContinuePrompts;
